import {
  CONTROL_BASE,
  HIDE_BEFORE_BORDER,
} from '@/app/components/forms/styles';
import { cnva } from '@/app/utils/cnva';

/**
 * Label for control (checkbox/radio).
 */
export const controlLabelStyled = cnva('text-body-1-fixed transition-color', {
  variants: {
    theme: {
      light: 'text-gray-900',
      dark: 'text-white',
    },
    disabled: {
      true: 'pointer-events-none text-gray-400',
    },
    error: {
      true: '',
    },
    checked: {
      true: '',
    },
    checkedDisabled: {
      true: '',
    },
  },
});

/**
 * Checkbox control styling.
 */
export const controlCheckboxStyled = cnva(
  [CONTROL_BASE, 'rounded-2xs size-6 before:rounded-xs'],
  {
    variants: {
      theme: {
        light: '',
        dark: '',
      },
      error: {
        true: '',
      },
      disabled: {
        true: '',
      },
      checked: {
        true: [
          'bg-red-500',
          'border-red-500 focus-within:border-red-500 hover:border-red-500',
          HIDE_BEFORE_BORDER,
        ],
      },
      checkedDisabled: {
        true: 'border-red-200 bg-red-200',
      },
    },
  }
);

/**
 * Radio control styling.
 */
export const controlRadioStyled = cnva(
  [
    CONTROL_BASE,
    'size-6 rounded-full',
    'before:rounded-full',
    'after:pointer-events-none after:size-3 after:rounded-full',
    'after:absolute after:top-1/2 after:left-1/2 after:-translate-x-1/2 after:-translate-y-1/2',
    'after:scale-0 after:transition-transform after:duration-300',
  ],
  {
    variants: {
      theme: {
        light: '',
        dark: '',
      },
      error: {
        true: '',
      },
      disabled: {
        true: '',
      },
      checked: {
        true: [
          'bg-transparent',
          'border-red-500 focus-within:border-red-500 hover:border-red-500',
          'after:scale-100 after:bg-red-500',
          HIDE_BEFORE_BORDER,
        ],
      },
      checkedDisabled: {
        true: 'border-red-200 after:bg-red-200',
      },
    },
  }
);

/**
 * Checkbox indicator styling (checkmark visibility).
 */
export const controlCheckboxIndicatorStyled = cnva(
  'transition-color absolute opacity-0',
  {
    variants: {
      theme: {
        light: 'text-white',
        dark: 'text-white',
      },
      checked: {
        true: 'opacity-100',
      },
      checkedDisabled: {
        true: '',
      },
    },
  }
);

/**
 * Toggle Switch control styling.
 */
export const controlToggleStyled = cnva(
  [CONTROL_BASE, 'peer h-6 w-11 rounded-full before:rounded-full'],
  {
    variants: {
      theme: {
        light: '',
        dark: '',
      },
      error: {
        true: '',
      },
      disabled: {
        true: '',
      },
      checked: {
        true: [
          'bg-transparent',
          'border-red-500 bg-red-500 focus-within:border-red-500 hover:border-red-500',
          HIDE_BEFORE_BORDER,
        ],
      },
      checkedDisabled: {
        true: 'border-red-200 bg-red-200',
      },
    },
  }
);

/**
 * Style for the toggle thumb control.
 */
export const controlToggleThumbStyled = cnva(
  'transition-bg-translate pointer-events-none absolute top-1 left-1 size-4 rounded-full',
  {
    variants: {
      theme: {
        light:
          'bg-gray-200 peer-focus-within:bg-gray-400 peer-hover:bg-gray-400',
        dark: 'bg-gray-400 peer-focus-within:bg-gray-300 peer-hover:bg-gray-300',
      },
      error: {
        true: '',
      },
      disabled: {
        true: '',
      },
      checked: {
        true: 'translate-x-5 bg-white peer-focus-within:bg-white peer-hover:bg-white',
      },
      checkedDisabled: {
        true: '',
      },
    },
    compoundVariants: [
      {
        theme: 'light',
        error: true,
        className: 'peer-focus-within:bg-gray-200 peer-hover:bg-gray-200',
      },
      {
        theme: 'dark',
        error: true,
        className: 'peer-focus-within:bg-gray-400 peer-hover:bg-gray-400',
      },
    ],
  }
);
